import React from "react";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="61">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#672E9B"
          d="M34.71 61c16.419 0 25.002-15.139 27.95-30.884C65.607 14.371 48.884 4.042 32.93.481 16.98-3.079 0 13.75 0 30.116S18.292 61 34.71 61z"
        ></path>
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M45 20.012a12.935 12.935 0 01-3.71 1.79 5.33 5.33 0 00-5.884-1.457A5.244 5.244 0 0032 25.314v1.17a12.639 12.639 0 01-10.636-5.302s-4.728 10.533 5.909 15.214A13.855 13.855 0 0119 38.737c10.636 5.852 23.636 0 23.636-13.459a5.217 5.217 0 00-.094-.97A9.013 9.013 0 0045 20.011z"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
